import URI from 'jsuri';

import API from 'js/lib/api';
import path from 'js/lib/path';
import user from 'js/lib/user';

const openCourseAPI = API('/api/opencourse.v1', { type: 'rest' });

const VideoProgressEventAPIUtils = {
  sendEvent(type: string, itemId: string, courseSlug: string) {
    const options = {
      data: {
        contentRequestBody: {},
      },
    };

    const uri = new URI(
      path.join('user', `${user.get().id}`, 'course', courseSlug, 'item', itemId, 'lecture/videoEvents', type)
    );

    return openCourseAPI.post(uri.toString(), options);
  },
};

export default VideoProgressEventAPIUtils;

export const { sendEvent } = VideoProgressEventAPIUtils;
